const LLS_SIZE = 1024 * 1024 * 256;

class Storage {
    constructor() {
        this.storage = null;
        this.initialized = false;
    }

    init() {
        this.storage = new lls({size: LLS_SIZE, name: `cirrusmed_${config.instanceSuffix}`});
        return this.storage.initialized.then((grantedCapacity) => {
            if (grantedCapacity !== -1 && grantedCapacity !== LLS_SIZE) {
                console.warn('Capacity of storage less then usual');
            }
            this.initialized = true;
            if (__DEV__) {
                this.storage.ls().then((listing) => {
                    console.info('----Saved documents locally----');
                    console.log(listing);
                    console.info('-------------------------------');
                });
            }
        });
    }

    isInitialized() {
        return this.initialized;
    }

    set(key, value) {
        return this.storage.setContents(key, JSON.stringify(value));
    }

    setAttachment(mainKey, attachmentKey, value) {
        return this.storage.setAttachment(mainKey, attachmentKey, value);
    }

    get(key) {
        return this.storage.getContents(key).then((jsonValue) => JSON.parse(jsonValue));
    }

    getAttachment(key, attachmentKey) {
        return this.storage.getAttachment(key, attachmentKey);
    }

    remove(key) {
        return this.storage.remove(key);
    }

    removeAttachment(key, attachmentKey) {
        return this.storage.rmAttachment(key, attachmentKey);
    }
}

export default new Storage();



// WEBPACK FOOTER //
// ./src/sources/localStorage/Storage.js